import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { useNmmDomains } from '../../../../../hooks/useNmmDomains';
import { selectEntitiesByFilters } from '../../../../../store/views/entityView';
import { currentCoursesByDomainFilters, studyGroupsByDomainFilters } from '../../../../../utils/entitiesFiltersUtils';
import ChangeNmm from '../../../../../../teacher/pages/myLearningPage/myLearningNmmPage/changeNmm/ChangeNmm';
import Text from '../../../../features/text/Text';
import pathRouts from '../../../../../enums/pathRoute';
import Icon from '../../../../ui/icons/Icon';
import iconsList from '../../../../ui/icons/iconsList';
import MatriculationCounters from './matriculationCounters/MatriculationCounters';
import classes from './MyLearningDomainHeader.module.css';

const MyLearningDomainHeader = ({ domain, nmmId }) => {

    const { texts } = useSelector(state => state.translate);
    const { isStudent } = useSelector(state => state.auth);
    const { domainName } = useParams();
    const navigate = useNavigate()
    const nmmDomains = useNmmDomains();
    const filters = useMemo(() => currentCoursesByDomainFilters(domainName, nmmId, nmmDomains, domain?.nmmIds), [domainName, nmmId, nmmDomains, domain?.nmmIds]);
    const courses = useSelector(state => selectEntitiesByFilters(state, filters));
    const studyGroupsByDomainFilter = useMemo(() => studyGroupsByDomainFilters(domainName), [domainName]);
    const studyGroups = useSelector(state => selectEntitiesByFilters(state, studyGroupsByDomainFilter))

    const teachers = useMemo(() => {
        const allTeachers = [];
        courses?.forEach(course => {            
            if (Array.isArray(course.teachers)) {
                course.teachers.forEach(t => t && allTeachers.push(t));
            }
        });
        studyGroups?.forEach(group => {
            if (Array.isArray(group.teachers))
                group.teachers.forEach(t => t && allTeachers.push(t));
        });
        const uniqueByKey = [];
        const seen = new Set();
        allTeachers.forEach(teacher => {
            const tKey = teacher.firstName && teacher.lastName ? `${teacher.firstName} ${teacher.lastName}` : teacher.name;
            if (tKey && !seen.has(tKey)) {
                seen.add(tKey);
                uniqueByKey.push(teacher);
            }
        });
        return uniqueByKey;
    }, [courses, studyGroups]);

    const teachersNames = teachers.map(t => t.firstName && t.lastName ? `${t.firstName} ${t.lastName}` : t.name).join(", ");

    return (
        <div className={classes.WrappDiv}>
            <div className={classes.DomainHeader}>
                <div className={classes.DomainInfo}>
                    {/* <div className={classes.DomainTitleRow}> */}
                    <div className={classes.BackArrow} onClick={() => navigate(`/${pathRouts.MYLEARNING}`)}>
                        <Icon name={iconsList.arrows} color={"black"} />
                    </div>
                    <img src={domain?.cardDomainImg || domain?.matriculation?.cardDomainImg} className={classes.DomainImg} alt={domain?.text} />
                    <Text className={classes.DomainTitle}>{domain?.text}</Text>
                    {!isStudent ?
                        <ChangeNmm nmmsByDomain={studyGroups} />
                        :
                        teachersNames && (
                            <div className={classes.DomainTeachers}>{texts.teacher}: {teachersNames}</div>
                        )
                    }
                    {/* </div> */}

                </div>
                <MatriculationCounters domainName={domainName} />
            </div>
        </div >
    )
}
export default MyLearningDomainHeader;


